export default __webpack_public_path__ + "static/receptiviti-light-theme-4e542010be99d9375b25a0f5f2338bc8.png";